// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"F_cr","summary__stats__links":"F_cs","summary__stats__links__single":"F_ct"};